import React, {useEffect, useState} from "react";
import {Option} from "./Option/option";
import {makeStyles} from "@mui/styles";
import {useMediaQuery} from "react-responsive";

const useStyles = makeStyles(theme => ({
    selectWrapper: props => ({
        width: `100%`,
        marginRight: `2px`,
        backgroundColor: `transparent`,
        border: `1px solid white`,
        borderRadius: `3px`,
        height: `34px`,
        color: `white`,
        minWidth: `100px`,
        maxWidth: props.isLaptop ? `100px` : `150px`,

    }),
}));

export const Select = (props) => {
    const isLaptop = useMediaQuery({query: '(max-width: 1536px)'});
    const stylesProperties = {
        isLaptop: isLaptop
    }
    const classes = useStyles(stylesProperties);
    const [isHasEmptyOption, setEmptyOptionStatues] = useState(false);

    useEffect(() => {
        if (props.isHasEmptyOption) {
            setEmptyOptionStatues(true);
        } else {
            setEmptyOptionStatues(false)
        }

    }, [props.isHasEmptyOption])

    const options = props.options.map((elem) => {
        if (elem.name) {
            const isSelected = elem.code === props.selectedOption;
            return (
                <Option key={elem.code} selected={isSelected} elem={elem}/>
            )
        } else {
            const isSelected = elem === props.selectedOption;
            return (
                <Option key={elem} selected={isSelected} elem={elem}/>
            )
        }
    });

    return (
        <select value={props.selectedOption} onChange={props.onChange} className={classes.selectWrapper}>
            {isHasEmptyOption && <Option selected={props.isSelected} elem={''}/>}
            {options}
        </select>
    )
}